module.exports = require("core-js/library/fn/set");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs2/core-js/set.js
// module id = 245
// module chunks = 0 1